import { render, staticRenderFns } from "./RegiaoUoUnidadeDashboard.vue?vue&type=template&id=5e1ee0a2&"
import script from "./RegiaoUoUnidadeDashboard.vue?vue&type=script&lang=js&"
export * from "./RegiaoUoUnidadeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports